import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

export default function MissionCountdown({ dateDebut, dateFin, statut }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(t);
  }, []);

  if (!dateDebut) return null;
  const start = new Date(dateDebut).getTime();
  const end = dateFin ? new Date(dateFin).getTime() : null;
  const nowMs = now;

  let label, value, color;
  if (statut === "archivee" || statut === "desactivee") {
    return <span className="text-xs text-slate-400 italic">—</span>;
  }
  if (nowMs < start) {
    const diff = start - nowMs;
    value = formatDuration(diff);
    label = "Démarre dans";
    color = "#C5A059";
  } else if (end && nowMs > end) {
    label = "Terminée depuis";
    value = formatDuration(nowMs - end);
    color = "#64748B";
  } else {
    label = end ? "Se termine dans" : "En cours depuis";
    value = end ? formatDuration(end - nowMs) : formatDuration(nowMs - start);
    color = end && (end - nowMs) < 3 * 24 * 3600 * 1000 ? "#EF4444" : "#10B981";
  }
  return (
    <div className="inline-flex items-center gap-1 text-xs rounded px-2 py-1" style={{ backgroundColor: `${color}15`, color }}>
      <Clock className="h-3 w-3" />
      <span className="font-mono font-semibold">{value}</span>
      <span className="opacity-70">· {label}</span>
    </div>
  );
}

function formatDuration(ms) {
  const abs = Math.abs(ms);
  const days = Math.floor(abs / 86_400_000);
  const hours = Math.floor((abs % 86_400_000) / 3_600_000);
  const mins = Math.floor((abs % 3_600_000) / 60_000);
  if (days > 7) return `${days} j`;
  if (days > 0) return `${days}j ${hours}h`;
  if (hours > 0) return `${hours}h ${mins}m`;
  return `${mins}m`;
}
